import React from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import WhoIAm from "./components/WhoIAm";
import About from "./components/About";
import BrandsCarousel from "./components/BrandsCarousel";
import MyJourney from "./components/MyJourney";
import GlobalMarkets from "./components/GlobalMarkets";
import IndustriesCovered from "./components/IndustriesCovered";
import DomainExpertise from "./components/DomainExpertise";
import WhatIveBuilt from "./components/WhatIveBuilt";
import HowIWork from "./components/HowIWork";
import ConsultationCTA from "./components/ConsultationCTA";
import Education from "./components/Education";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <WhoIAm />
        <About />
        <BrandsCarousel />
        <MyJourney />
        <GlobalMarkets />
        <IndustriesCovered />
        <DomainExpertise />
        <WhatIveBuilt />
        <HowIWork />
        <ConsultationCTA />
        <Education />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
